export function blockImageColumns(){
    document.querySelectorAll('.image-columns-block').forEach((block) => {
        let container = block.querySelector('.columns');

        if(!container) return false;

        let btn = block.querySelector('button')

        if(!btn){
            return false;
        }

        btn.addEventListener('click', () => {
            if(container.classList.contains('show')){
                container.classList.remove('show')
                btn.innerHTML = 'Show more'
            }else{
                container.classList.add('show')
                btn.innerHTML = 'Show less'
            }

        })
    })
}